import script from "./EntityNew.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityNew.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__